<template>
  <v-app>
    <!-- Menú Lateral -->
    <v-navigation-drawer
      v-model="drawer"
      :rail="rail"
      permanent
      class="pa-2"
      :width="drawer ? 300 : 80"
    >
      <!-- Botón de Expansión -->
      <v-btn icon class="expand-button" @click.stop="rail = !rail">
        <v-icon>{{ rail ? "mdi-chevron-right" : "mdi-chevron-left" }}</v-icon>
      </v-btn>

      <!-- Título con Ícono -->
      <v-list-item nav>
        <template #prepend>
          <v-icon large>mdi-folder-multiple</v-icon>
        </template>
        <v-list-item-title class="text-h6">Manuales</v-list-item-title>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Lista de Carpetas y Documentos -->
      <v-list dense>
        <FolderItem
          v-for="(folder, index) in menu.categories"
          :key="index"
          :folder="folder"
          :rail="rail"
          @select-doc="selectDoc"
        />
      </v-list>
    </v-navigation-drawer>

    <!-- Área de Visualización -->
    <v-main>
      <v-container
        fluid
        class="fill-height pa-2"
        style="max-height: calc(100vh - 100px)"
      >
        <v-row class="fill-height">
          <v-col cols="12" class="d-flex flex-column">
            <!-- Spinner de Carga -->
            <div
              v-if="loadingFile"
              class="d-flex align-center justify-center fill-height"
            >
              <v-progress-circular indeterminate color="primary" />
            </div>
            <!-- Visualización -->
            <div v-else-if="selectedFileUrl" class="flex-grow-1">
              <!-- Si es PDF -->
              <iframe
                v-if="selectedFileType === 'pdf'"
                :src="selectedFileUrl"
                style="width: 100%; height: 100%"
                frameborder="0"
              ></iframe>
              <!-- Si es MP4 -->
              <video
                v-else-if="selectedFileType === 'mp4'"
                controls
                :src="selectedFileUrl"
                style="width: 100%; height: 100%"
              ></video>
            </div>
            <!-- Mensaje Informativo -->
            <div v-else class="d-flex align-center justify-center fill-height">
              <v-alert type="info">
                Seleccione un documento para visualizarlo o reproducirlo
              </v-alert>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import api from "@/services/api.js";
import debounce from "lodash/debounce";
import FolderItem from "@/components/FolderItem.vue";

export default {
  name: "ManualesView",
  components: {
    FolderItem,
  },
  data() {
    return {
      drawer: true,
      rail: false,
      menu: { categories: [] },
      selectedFileUrl: null,
      selectedFileType: null,
      loadingFile: false,
      debouncedFilterMenu: null,
    };
  },
  mounted() {
    this.debouncedFilterMenu = debounce(this.filterMenu, 300);
    this.loadMenu();
  },
  methods: {
    async loadMenu() {
      try {
        const data = await api.getManuales();
        console.log("Menú recibido:", data);
        this.menu = data;
      } catch (error) {
        console.error("Error al obtener el menú:", error);
      }
    },
    async selectDoc(doc) {
      this.loadingFile = true;
      this.selectedFileUrl = null;
      this.selectedFileType = doc.type;
      try {
        const data = await api.getFileUrl(doc.id);
        console.log("URL del documento:", data.url);
        this.selectedFileUrl = data.url;
      } catch (error) {
        console.error("Error al obtener la URL:", error);
      } finally {
        this.loadingFile = false;
      }
    },
    filterMenu() {
      // Implementa filtrado recursivo si lo necesitas.
    },
  },
  beforeUnmount() {
    if (this.debouncedFilterMenu) {
      this.debouncedFilterMenu.cancel();
    }
  },
};
</script>

<style scoped>
.fill-height {
  height: 100%;
}
.v-navigation-drawer {
  height: 100vh;
  transition: width 0.3s;
  position: relative;
}
.expand-button {
  position: absolute;
  top: 10px;
  right: -20px;
  z-index: 1000;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
}
.flex-grow-1 {
  flex-grow: 1;
}
</style>
